import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from 'react';
import { Carousel, CarouselVariant, SliderNavVariant, GiftCardThumbSlide, Box, } from '@as/cotopaxi';
import { getImageFromCdn } from '../../util/ImageUtil';
export const GiftVoucherThumbSlider = ({ images, activeSlideIndex, imageCdnPrefix, onActiveSlideIndexChange, }) => {
    const [swiper, setSwiper] = useState(null);
    const onThumbClick = function (index) {
        if (index !== activeSlideIndex) {
            onActiveSlideIndexChange(index);
        }
    };
    const renderSlide = useCallback((image, index) => {
        const imagePath = getImageFromCdn(image, imageCdnPrefix);
        return (_jsx(Box, { role: "button", tabIndex: 0, onClick: () => onThumbClick(index), children: _jsx(GiftCardThumbSlide, { active: activeSlideIndex === index, imagePath: imagePath }) }, `gift_voucher_thumb_${index}`));
    }, [activeSlideIndex]);
    const giftVoucherSlideConfig = {
        variant: CarouselVariant.GIFT_CARD_THUMB,
        showPagination: false,
        arrowsConfig: {
            variant: SliderNavVariant.SEMICIRCLE,
        },
        configurationOverrides: {
            getSwiper: setSwiper,
            watchOverflow: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
        },
    };
    useEffect(() => {
        if (swiper !== null) {
            const activeSlide = swiper === null || swiper === void 0 ? void 0 : swiper.slides[activeSlideIndex];
            if ((activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.className.indexOf('swiper-slide-visible')) < 0) {
                swiper.slideTo(activeSlideIndex);
            }
        }
    }, [activeSlideIndex]);
    return _jsx(Carousel, Object.assign({}, giftVoucherSlideConfig, { children: images.map(renderSlide) }));
};
